// Drift Auditor -- underwater (drawdown) comparison: Drift vs Corridor.

import React from 'react';
import {
    Area,
    AreaChart,
    CartesianGrid,
    Legend,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts';

import type { TimeSeriesPoint } from '../types';

export const DrawdownChart: React.FC<{ data: TimeSeriesPoint[] }> = ({ data }) => (
    <div className="bg-white rounded-2xl shadow-sm border border-slate-100 p-5">
        <h3 className="text-base font-bold text-slate-800">Drawdown (Underwater)</h3>
        <p className="text-xs text-slate-500 mt-0.5 mb-3">
            How deep each discipline fell below its prior peak.
        </p>
        <div className="h-64 w-full">
            <ResponsiveContainer width="100%" height="100%">
                <AreaChart data={data} margin={{ top: 5, right: 8, left: 4, bottom: 0 }}>
                    <defs>
                        <linearGradient id="ddDrift" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#f43f5e" stopOpacity={0.35} />
                            <stop offset="95%" stopColor="#f43f5e" stopOpacity={0.02} />
                        </linearGradient>
                        <linearGradient id="ddCorr" x1="0" y1="0" x2="0" y2="1">
                            <stop offset="5%" stopColor="#6366f1" stopOpacity={0.3} />
                            <stop offset="95%" stopColor="#6366f1" stopOpacity={0.02} />
                        </linearGradient>
                    </defs>
                    <CartesianGrid strokeDasharray="3 3" stroke="#e2e8f0" vertical={false} />
                    <XAxis
                        dataKey="date"
                        tick={{ fontSize: 11, fill: '#94a3b8' }}
                        minTickGap={48}
                        tickLine={false}
                    />
                    <YAxis
                        tickFormatter={(v: number) => `${v.toFixed(0)}%`}
                        tick={{ fontSize: 11, fill: '#94a3b8' }}
                        width={44}
                        tickLine={false}
                        axisLine={false}
                    />
                    <Tooltip
                        formatter={(v: number) => `${v.toFixed(2)}%`}
                        contentStyle={{ borderRadius: 12, border: '1px solid #e2e8f0', fontSize: 12 }}
                    />
                    <Legend wrapperStyle={{ fontSize: 12 }} />
                    <Area
                        type="monotone"
                        dataKey="drifted_drawdown_pct"
                        name="Unchecked Drift"
                        stroke="#f43f5e"
                        strokeWidth={1.5}
                        fill="url(#ddDrift)"
                    />
                    <Area
                        type="monotone"
                        dataKey="corridor_drawdown_pct"
                        name="Tolerance Corridor"
                        stroke="#6366f1"
                        strokeWidth={1.5}
                        fill="url(#ddCorr)"
                    />
                </AreaChart>
            </ResponsiveContainer>
        </div>
    </div>
);
